import React, { useParams } from "react-router-dom";
import UserEdit from "./UserEdit";

const UserEditWrapped = () => {
  const { id } = useParams();
  return <UserEdit key={id} />;
};


export default UserEditWrapped;
